import { IAlreadyConnectedPersonManagerInfo } from "../../../interfaces/error/IAlreadyAttachPersonToManagerData";

export function isIAlreadyConnectedPersonManagerInfo(
  obj: any,
): obj is IAlreadyConnectedPersonManagerInfo {
  return (
    typeof obj === "object" &&
    obj !== null &&
    typeof obj.surname === "string" &&
    typeof obj.name === "string" &&
    typeof obj.patronymic === "string" &&
    typeof obj.id === "number"
  );
}
